import { render } from "./drawer-advance-detail.vue?vue&type=template&id=63a1ecdf&scoped=true"
import script from "./drawer-advance-detail.vue?vue&type=script&lang=js"
export * from "./drawer-advance-detail.vue?vue&type=script&lang=js"

import "./drawer-advance-detail.vue?vue&type=style&index=0&id=63a1ecdf&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a1ecdf"]])

export default __exports__